<template>
    <div id="ClaimCollectionList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Claim Collection List</div>

                    <div class="web-action-btn">
                        <div class="btn-groups text-right">                    <!-- Button for Clear Cache -->
                    <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                            <!-- <router-link v-if="canAddCom" class="btn btn-primary" v-bind:to="{name: 'ClaimCollection'}" > <i class="fp-add"></i> Add</router-link> -->
                            <router-link class="btn btn-secondary" v-bind:to="{name: 'WarrantyClaimList'}" > <i class="fp-back"> </i> Back</router-link>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-list">
                        <data-table-filter-config :moduleName="'claimCollectionList'" ref="filterComponent" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'claimCollectionList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listClaimCollectionTable"
                                    mode="remote"
                                    title="Claim Collection"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }"
                                    :sort-options="{
                                      enabled: true,
                                      initialSortBy: {field: 'unit_no', type: 'asc'}
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="View Claim Collection" v-if="canUpdateCom" class="fp-view mr-3" v-bind:to="{name: 'ClaimCollectionView',params:{id:props.row.id},query:{claim:props.row.claim_id}}"></router-link>
                                                <a href="javascript:void(0)" title="Edit Claim Collection" v-if="canUpdateCom && props.row.status != 'Closed'" class="fp-edit mr-3" v-on:click="claimCollectionEdit(props.row.id,props.row.claim_id)"></a>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button id="deleteCollectionBtn" v-if="deleteCollection" v-on:click.prevent="collectionDelete" class="btn btn-danger">Delete</button>
                                        <button id="closeCollection" v-on:click.prevent="collectionClose" class="btn btn-danger">Close</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ClaimCollectionList",
        metaInfo() {
            return {title: "Warranty Claim Collection List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
                {
                    label: '# Claim',
                    field: 'claim_number',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Claim", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Work Order Item',
                    field: 'wo_item_id',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#Unit',
                    field: 'unit_no',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "#Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Vendor',
                    field: 'vendor',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#Vendor Claim',
                    field: 'vendor_claim_number',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor Claim No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Warranty',
                    field: 'warranty',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Category", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Claim Date',
                    field: 'claim_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Collection Date',
                    field: 'collection_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Collection Amount',
                    field: 'collection_amount',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Outstanding Amount',
                    field: 'outstanding_amount',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Open', 'Close'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Disposition',
                    field: 'disposition',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Disposition", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            component_value: false,
            loading:false,
            canUpdateCom:false,
            canAddCom:false,
            deleteCollection:false,
            action:'list'
            // pageKey:"__list_",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_claim_collection') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_claim_collection') {
                            self.canAddCom = true;
                            self.canUpdateCom = true;
                        }
                        if (permissions[i].name == 'delete_claim_collection') {
                            self.deleteCollection = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listClaimCollectionTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                // var path = window.location.pathname;
                // var segments = path.split("/");

                var data = this.$refs['listClaimCollectionTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listClaimCollectionTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // claim_id:segments[3],
                    selectedRows:use,
                    action:self.action,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/claim-collection/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "delete" || self.action == "close" ) {

                                self.action = "list";
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }

                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'component-list')
                    }
                });
            },

            collectionDelete() {
                var self = this;
                 self.$swal({
                    title: 'Are you sure that you want to delete this Collection?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      this.action = "delete";
                      this.loadList();

                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Collection?')) {
                // }
            },
            collectionClose() {
                var data = this.$refs['listClaimCollectionTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    if (this.$refs['listClaimCollectionTable'].selectedRows[i].woStatus == 'closed' || this.$refs['listClaimCollectionTable'].selectedRows[i].woStatus == 'approved'){

                        use.push(this.$refs['listClaimCollectionTable'].selectedRows[i].id)

                    }else{
                        self.$swal('','One or more collection have open work order','info');
                        return;
                    }
                }

                if (confirm('Are you sure that you want to close this Collection?')) {

                    this.action = "close";
                    this.loadList();
                }
            },
            claimCollectionEdit:function(id,claimId){
                var self = this;

                self.$router.push('/claim-collection/edit/'+id+'?claim='+claimId);

            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ClaimCollectionList.vue